import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { NoOpEncoder_getInstance2wgh00a9s97su as NoOpEncoder_getInstance } from '../internal/NoOpEncoder.mjs';
import {
  encodeNotNullMark352dnk5r97tvq as encodeNotNullMark,
  beginCollection27i47rk9upjw4 as beginCollection,
  encodeSerializableValue1mu7jsn2oheqi as encodeSerializableValue,
  encodeNullableSerializableValue22qo2euy9x1r4 as encodeNullableSerializableValue,
  shouldEncodeElementDefault1vy568gzcy4z0 as shouldEncodeElementDefault,
  Encoderqvmrpqtq8hnu as Encoder,
  CompositeEncoderknecpkexzn3v as CompositeEncoder,
} from './Encoding.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractEncoderClass;
function AbstractEncoder() {
  if (AbstractEncoderClass === VOID) {
    class $ {
      static w1r() {
        return createThis(this);
      }
      d1r(descriptor) {
        return this;
      }
      e1r(descriptor) {
      }
      x1r(descriptor, index) {
        return true;
      }
      y1r(value) {
        throw SerializationException().h1o('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
      }
      z1r() {
        throw SerializationException().h1o("'null' is not supported by default");
      }
      a1s(value) {
        return this.y1r(value);
      }
      b1s(value) {
        return this.y1r(value);
      }
      c1s(value) {
        return this.y1r(value);
      }
      d1s(value) {
        return this.y1r(value);
      }
      e1s(value) {
        return this.y1r(value);
      }
      f1s(value) {
        return this.y1r(value);
      }
      g1s(value) {
        return this.y1r(value);
      }
      h1s(value) {
        return this.y1r(new (Char())(value));
      }
      i1s(value) {
        return this.y1r(value);
      }
      j1s(enumDescriptor, index) {
        return this.y1r(index);
      }
      k1s(descriptor) {
        return this;
      }
      l1s(descriptor, index, value) {
        if (this.x1r(descriptor, index)) {
          this.a1s(value);
        }
      }
      m1s(descriptor, index, value) {
        if (this.x1r(descriptor, index)) {
          this.b1s(value);
        }
      }
      n1s(descriptor, index, value) {
        if (this.x1r(descriptor, index)) {
          this.c1s(value);
        }
      }
      o1s(descriptor, index, value) {
        if (this.x1r(descriptor, index)) {
          this.d1s(value);
        }
      }
      p1s(descriptor, index, value) {
        if (this.x1r(descriptor, index)) {
          this.e1s(value);
        }
      }
      q1s(descriptor, index, value) {
        if (this.x1r(descriptor, index)) {
          this.f1s(value);
        }
      }
      r1s(descriptor, index, value) {
        if (this.x1r(descriptor, index)) {
          this.g1s(value);
        }
      }
      s1s(descriptor, index, value) {
        if (this.x1r(descriptor, index)) {
          this.h1s(value);
        }
      }
      t1s(descriptor, index, value) {
        if (this.x1r(descriptor, index)) {
          this.i1s(value);
        }
      }
      u1s(descriptor, index) {
        return this.x1r(descriptor, index) ? this.k1s(descriptor.p1p(index)) : NoOpEncoder_getInstance();
      }
      v1s(descriptor, index, serializer, value) {
        if (this.x1r(descriptor, index)) {
          this.w1s(serializer, value);
        }
      }
      x1s(descriptor, index, serializer, value) {
        if (this.x1r(descriptor, index)) {
          this.y1s(serializer, value);
        }
      }
    }
    protoOf($).z1s = encodeNotNullMark;
    protoOf($).a1t = beginCollection;
    protoOf($).w1s = encodeSerializableValue;
    protoOf($).y1s = encodeNullableSerializableValue;
    protoOf($).b1t = shouldEncodeElementDefault;
    initMetadataForClass($, 'AbstractEncoder', VOID, VOID, [Encoder(), CompositeEncoder()]);
    AbstractEncoderClass = $;
  }
  return AbstractEncoderClass;
}
//region block: exports
export {
  AbstractEncoder as AbstractEncoder2gxtu3xmy3f8j,
};
//endregion

//# sourceMappingURL=AbstractEncoder.mjs.map
